import { useMemo } from "react";
import { RootState } from "../redux/store";
import { useTypedSelector } from "./useTypedSelector";

/**
 * Returns a grid-template-columns string with each column width in vw minus its proportional share of the sidebar offset in px.
 * @param widths - Array of original column widths (numbers, any unit)
 * @param designBaseWidthPx - // The screen width of the original design in px
 * @param multiplier - The multiplier for your vw calculation (default: 100)
 */
export function useProportionalGridTemplateColumns(
  widths: number[],
  designBaseWidthPx = 2580,
  multiplier = 100
) {
  const sidebarState = useTypedSelector((state: RootState) => state.sidebar);

  return useMemo(() => {
    const totalWidth = widths.reduce((a, b) => a + b, 0);
    const sidebarOffset = sidebarState.isFixed /* && sidebarState.isOpen  */
      ? 240
      : 48;
    return widths
      .map((w) => {
        const vw = ((w * multiplier) / designBaseWidthPx).toFixed(4);
        const pxOffset = ((w / totalWidth) * sidebarOffset).toFixed(2);
        return `calc(${vw}vw - ${pxOffset}px)`;
      })
      .join(" ");
  }, [
    widths,
    sidebarState.isFixed,
    sidebarState.isOpen,
    designBaseWidthPx,
    multiplier,
  ]);
}